module.exports = __webpack_public_path__ + "static/media/traffic-light-stop.7957b482.svg";